/* eslint-disable import/prefer-default-export */

// venueName: string,
// cuisine: string,
// neighborhood: string,
// price: string,
export const ariaLabelVenue = (
  ...strs
) => (strs.filter((str) => !!str).join(', ') || 'Link to Venue');
